/* eslint-disable @typescript-eslint/no-empty-function */
import { useEffect, useState } from 'react';

import { Button } from 'antd';
import { MasterUseCaseInterface } from 'application/usecases/MasterUseCase';
import { PropertyUseCaseInterface } from 'application/usecases/PropertyUseCase';
import { ImageComponent } from 'presentation/components/ImageComponent';
import { openErrorNoti } from 'presentation/components/Notification';
import { PageTitle } from 'presentation/components/PageTitle';
import {
    completeFetching,
    showConfirm,
    startFetching,
} from 'presentation/redux/features/app/appSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useNavigate, useParams } from 'react-router-dom';
import { MASTER_CATEGORY_LIST } from 'utilities/constants/COMMON';
import { commonHelpers } from 'utilities/helpers';
import { DetailProperty } from '../CU-031-01/models/DetailProperty';
import { Detail } from './components/Detail';
import { DataDetailProperty } from './models/Model_CU-030-01';

interface props {
    propertyUseCase: PropertyUseCaseInterface;
    masterUseCase: MasterUseCaseInterface;
}

const CU03001Page = ({ propertyUseCase, masterUseCase }: props) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const { propertyId } = useParams();

    const [detailProperty, setDetailProperty] = useState<DataDetailProperty>({
        id: 0,
        residence: '',
        propertyName: '',
        propertyImages: [],
        closetStationRequiredMins: 0,
        footMin: 0,
        stationName: '',
        lineName: '',
        floors: '0',
        builtAt: '',
        structure: '',
        numOfUnit: 0,
    });

    useEffect(() => {
        getDetailProperty({ propertyId: Number(propertyId) });
    }, []);

    const getDetailProperty = async (params: { propertyId: number }) => {
        try {
            dispatch(startFetching());
            const response = await Promise.all([
                propertyUseCase.getDetailProperty(params),
                masterUseCase.getMasterSubCategoryList({
                    categoryCode: MASTER_CATEGORY_LIST.STRUCTURE_CODE,
                }),
            ]);
            const propertyDetail = response[0]?.result as DetailProperty;
            const options = response[1].result;
            if (propertyDetail) {
                propertyDetail.structure =
                    options.find((option) => option.code === propertyDetail.structure)?.codeName ??
                    '';
                setDetailProperty(propertyDetail);
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const putMasterPropertyRegisterListingInformation = async (params: { propertyId: number }) => {
        try {
            dispatch(startFetching());
            const response = await masterUseCase.putMasterPropertyRegisterListingInformation({
                mstPropertyId: params.propertyId,
            });
            if (response.result)
                navigate(
                    `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_031_01}/${propertyId}/${response.result}`,
                );
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const showModalConfirm = () => {
        const confirmProps = commonHelpers.getConfirmProps('P012', {
            onOk: () => {
                putMasterPropertyRegisterListingInformation({
                    propertyId: Number(propertyId),
                });
            },
        });
        dispatch(showConfirm(confirmProps));
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
            }}
            className="CU-030-01-container"
        >
            <PageTitle title="くわしく査定" />
            <section className="width-full-screen height-full-screen">
                    <div className="title-2 mb-21">物件詳細</div>
                    <section>
                        <div style={{ display: 'flex', flexWrap: 'wrap'}}>
                            {detailProperty?.propertyImages.length > 0 ? (
                                (
                                    <div style={{ marginRight: 20 }}>
                                        <ImageComponent
                                            width="455px"
                                            alt=""
                                            src={detailProperty?.propertyImages[0].fileUrl}
                                    />
                                    </div>
                           )): ( 
                                <div className="image-container" style={{ marginRight: 80 }}>
                                    <ImageComponent
                                        width="455px"
                                        alt=""
                                        src={detailProperty?.propertyImages}
                                    />
                                </div>
                            )}
                            <section style={{ width: 343 }}>
                                <Detail data={detailProperty} />
                                <Button
                                    className="button-login-text"
                                    type="primary"
                                    style={{ width: '100%', height: 56, marginTop: 16 }}
                                    onClick={showModalConfirm}
                                >
                                    所有物件情報の入力に進む
                                </Button>
                            </section>
                        </div>
                    </section>
            </section>
        </div>
    );
};
export default CU03001Page;
